<template>
  <b-modal 
    id="inquiry-modal" 
    v-model="showModal" 
    title="产品询价" 
    size="md"
    centered
    hide-footer
    @hidden="onModalHidden"
  >
    <template #modal-header="{ close }">
      <div class="modal-header-custom d-flex align-items-center justify-content-between w-100">
        <div class="d-flex align-items-center">
          <b-icon icon="telephone-fill" variant="primary" font-scale="1.5" class="mr-2"></b-icon>
          <h4 class="modal-title mb-0 text-primary">产品询价</h4>
        </div>
        <b-button variant="link" @click="close()" class="close-btn">
          <b-icon icon="x" font-scale="1.5"></b-icon>
        </b-button>
      </div>
    </template>

    <div class="inquiry-content">
      <!-- 欢迎信息 -->
      <div class="welcome-section text-center mb-4">
        <b-icon icon="telephone" variant="primary" font-scale="3" class="mb-3"></b-icon>
        <h5 class="text-primary mb-2">欢迎来电咨询产品价格</h5>
        <p class="text-muted mb-0">我们的专业销售团队将为您提供详细的产品信息和优惠报价</p>
      </div>

      <!-- 联系电话 -->
      <div class="contact-phone-section mb-4">
        <div class="phone-display d-flex align-items-center justify-content-center p-3 bg-light rounded">
          <b-icon icon="telephone-fill" variant="primary" class="mr-2"></b-icon>
          <span class="phone-number">13149833389</span>
        </div>
      </div>

      <!-- 服务信息 -->
      <div class="service-info mb-4">
        <div class="row">
          <div class="col-6">
            <div class="info-item d-flex align-items-center">
              <b-icon icon="clock" variant="secondary" class="mr-2"></b-icon>
              <div>
                <div class="info-label">工作时间</div>
                <div class="info-value">周一至周日 08:00-17:00</div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="info-item d-flex align-items-center">
              <b-icon icon="people" variant="secondary" class="mr-2"></b-icon>
              <div>
                <div class="info-label">专业服务</div>
                <div class="info-value">技术支持 + 价格咨询</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="action-buttons">
        <b-button 
          variant="primary" 
          size="lg" 
          block 
          class="mb-3 call-now-btn"
          @click="callNow"
        >
          <b-icon icon="telephone-fill" class="mr-2"></b-icon>
          立即拨打
        </b-button>
        <b-button 
          variant="outline-secondary" 
          size="lg" 
          block 
          @click="contactLater"
        >
          稍后联系
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'InquiryModal',
  props: {
    product: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    show() {
      this.showModal = true
    },
    hide() {
      this.showModal = false
    },
    onModalHidden() {
      this.$emit('hidden')
    },
    callNow() {
      // 尝试拨打电话（在移动设备上有效）
      window.location.href = 'tel:13149833389'
      this.hide()
    },
    contactLater() {
      this.hide()
      // 用户选择稍后联系，直接关闭弹窗
    }
  }
}
</script>

<style scoped>
.modal-header-custom {
  border-bottom: 1px solid #dee2e6;
  padding: 1rem 1.5rem;
}

.close-btn {
  padding: 0;
  border: none;
  background: none;
  color: #6c757d;
}

.close-btn:hover {
  color: #495057;
}

.inquiry-content {
  padding: 1rem;
}

.welcome-section h5 {
  font-weight: 600;
}

.phone-display {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%) !important;
  border: 2px solid #2196f3;
}

.phone-number {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1976d2;
  letter-spacing: 1px;
}

.info-item {
  margin-bottom: 1rem;
}

.info-label {
  font-size: 0.875rem;
  color: #6c757d;
  font-weight: 500;
}

.info-value {
  font-size: 0.875rem;
  color: #495057;
  font-weight: 600;
}

.call-now-btn {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  border: none;
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  transition: all 0.3s ease;
}

.call-now-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(25, 118, 210, 0.3);
}

.call-now-btn:active {
  transform: translateY(0);
}

/* 响应式设计 */
@media (max-width: 576px) {
  .phone-number {
    font-size: 1.25rem;
  }
  
  .service-info .row {
    flex-direction: column;
  }
  
  .service-info .col-6 {
    margin-bottom: 1rem;
  }
}
</style>